import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import {useParams} from 'react-router-dom';
import {baseUrl, formatDateTime, ipAddress, userLocation, userName} from '../Univ.js'
function IpAdvance(props) {
    const {ip_id} = useParams();
    const [ipData, setIpData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [advData, setadvData] = useState({
        "ip": '',
        "advance": '',
        "adv_type": '',
        "adv_status": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        fetchData();
    }, []);
    function fetchData() {
        axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
            .then(response => {
                setIpData([response.data]);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const inputHandler = (event) => {
        const {name, value} = event.target;
        const updatedadvData = {...advData, [name]: value};
        setadvData(updatedadvData);
    };
    const formSubmit = (e) => {
        e.preventDefault();
        const adv_type = document.getElementById("adv_type").value;
        const _formData = new FormData();
        _formData.append('ip', ip_id);
        _formData.append('advance', advData.advance);
        _formData.append('adv_type', adv_type);
        _formData.append('adv_status', '1');
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        axios.post(`${baseUrl}ip-adv-create/`, _formData)
            .then(response => {
                if (response.status == 200 || response.status == 201) {
                    Swal.fire({
                        title: 'Advance has been added.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setadvData({
                        ip_id: '',
                        advance: '',
                        adv_type: '',
                        adv_status: '',
                        status: '',
                        addedby: '',
                        ip_add: '',
                    });
                    setTimeout(() => {
                        window.location.href = '/ip-pat-view/' + ip_id + '/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to add min entry. Please try again later.',
                    'error'
                );
            });
    };
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{color: 'red'}}></i>
                Primary Consultant - Dr.{ipData.map(row => row.primary_consult.consultant)}
            </h3>
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Patient</th>
                        <th>IP ID</th>
                        <th>Patient ID</th>
                        <th>Patient Name</th>
                        <th>Gender</th>
                        <th>D.O.B/Age</th>
                        <th>Mobile</th>
                        <th>Regd. On</th>
                    </tr>
                    </thead>

                    <tbody>
                    {ipData.map((patientData, index) => (
                        <tr>
                            <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail"
                                     style={{width: 120, height: 60}}/></td>
                            <td>{patientData.ip_id}</td>
                            <td>{patientData.pat.pat_id}</td>
                            <td>{patientData.pat.patient}</td>
                            <td>{patientData.pat.gender}</td>
                            <td>{patientData.pat.age}</td>
                            <td>{patientData.pat.mobile}</td>
                            <td>{formatDateTime(patientData.admit_date)}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div>
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-indian-rupee-sign" aria-hidden="true" style={{color: 'red'}}></i>
                    Advance Request
                </h3>
                <form>
                    <div className="row">
                        <div className="col-md-3">
                            <label htmlFor="Advance" className="form-label">Advance</label>
                            <input
                                type="number"
                                min={0}
                                step="1"
                                className="ms-2 me-5"
                                value={advData.advance}
                                name="advance"
                                id="advance"
                                onChange={(e) => {
                                    let value = e.target.value;
                                    // Allow only non-negative integers (including empty for typing)
                                    if (!/^\d*$/.test(value)) return;
                                    inputHandler(e);
                                }}
                                onKeyDown={(e) => {
                                    // Block negative, decimal, scientific notation
                                    if (e.key === "-" || e.key === "." || e.key === "e") {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="Advance Type" className="form-label">Advance Type</label>
                            <select className="form-control"
                                    value={advData.adv_type}
                                    onChange={inputHandler}
                                    name="adv_type" id="adv_type">
                                <option value="Advance">Advance</option>
                                <option value="Final">Final Settlement</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                         className='ms-5'>
                        <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
                    </div>
                </form>

            </div>
        </section>
    )
}
export default IpAdvance;